export const exportReportHostTaskText = {
  successExportText: 'Download file Report berhasil',
  failedExportText: 'Download file Report gagal!',
  loadingExportText: 'Sedang mendownload file Report',
};
